import { StatsStoreBroker } from './broker';

export function StatsStoreBrokerFactory(): StatsStoreBroker {
  return new StatsStoreBroker();
}
